export interface Person {
  id: string
  name: string
  email: string
  phone?: string
  role_title: string // e.g., VP Marketing, Sr. Buyer
  function:
    | 'Marketing'
    | 'Procurement'
    | 'IT'
    | 'Finance'
    | 'Operations'
    | 'Legal'
    | 'Executive'
    | 'Agency'
  side: 'Client' | 'Quad'
  location?: string
  tags?: string[] // e.g., 'Decision Maker', 'Finance Gatekeeper'
  last_touch?: string // ISO date
  // Legacy fields for backward compatibility
  role?: string
  organization?: 'Quad' | 'Client'
  department?: string
  bio?: string
  profilePhoto?: string
  expertise?: string[]
  status?: 'available' | 'busy' | 'away'
  lastActive?: string
}
// Type guards
export function isValidPerson(person: any): person is Person {
  return (
    person &&
    typeof person.id === 'string' &&
    typeof person.name === 'string' &&
    typeof person.email === 'string' &&
    typeof person.role_title === 'string' &&
    ['Client', 'Quad'].includes(person.side)
  )
}
export function isValidAccount(account: any): account is Account {
  return (
    account &&
    typeof account.id === 'string' &&
    typeof account.name === 'string' &&
    Array.isArray(account.bots) &&
    Array.isArray(account.client_contacts) &&
    Array.isArray(account.quad_team)
  )
}
export interface Asset {
  id: string
  title: string
  kind: 'PDF' | 'Doc' | 'Image' | 'Link'
  url: string
  last_updated: string
  externalId?: string
  syncedAt?: string
}
export interface Workstream {
  name: string
  ownerId: string
  status: 'Active' | 'Paused' | 'At Risk'
  kpi?: string
}
export interface EscalationContact {
  name: string
  email: string
  role: string
}
export interface ProductFootprint {
  product: string
  utilization: number // 0-100
}
export interface Order {
  id: string
  title: string
  status: 'In Progress' | 'Delivered' | 'On Hold' | 'Planning'
  value: number
  date: string
}
export interface Account {
  id: string
  name: string
  logo_url: string
  industry: string
  region: string
  health: 'Green' | 'Yellow' | 'Red'
  primary_owner: Person
  products_services: string[]
  bots: Bot[]
  people: Person[] // Legacy: all people
  client_contacts: Person[] // New: client-side people
  quad_team: Person[] // New: Quad-side people
  assets: Asset[]
  kpis: { active_jobs: number; open_quotes: number; sla_alerts: number }
  last_sync: string
  workstreams?: Workstream[]
  escalation_contacts?: EscalationContact[]
  footprint?: ProductFootprint[]
  externalId?: string
  syncedAt?: string
  orders?: Order[]
  status?: 'Active' | 'Onboarding' | 'At Risk' | 'Paused'
  margin_health?: 'Healthy' | 'Moderate' | 'At Risk'
  last_activity?: string
}
export interface Bot {
  name: string
  type: 'external' | 'internal'
  link: string
  embed_code?: string
  api_snippet?: string
  api_endpoint?: string
  deep_link_partner_view?: string
  purpose: string
  bound_spaces: KnowledgeSpaceReference[]
  externalId?: string
  syncedAt?: string
}
export interface KnowledgeSpaceReference {
  id: string
  name: string
  visibility: 'Internal' | 'Partner'
}
export interface SeedData {
  categories: string[]
  users: Person[]
  accounts: Account[]
}
